<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot="menuLeft">
                <el-button type="primary"
                           icon="el-icon-plus"
                           size="small"
                           @click.stop="handleAlone()">新增文字单选
                </el-button>
                <el-button type="primary"
                           icon="el-icon-plus"
                           size="small"
                           @click.stop="handleMany()">新增文字多选
                </el-button>
                <el-button type="success"
                           icon="el-icon-plus"
                           size="small"
                           @click.stop="handleImageAlone()">新增图片单选
                </el-button>
                <el-button type="success"
                           icon="el-icon-plus"
                           size="small"
                           @click.stop="handleImageMany()">新增图片多选
                </el-button>
                <el-button type="info"
                           icon="el-icon-plus"
                           size="small"
                           @click.stop="handleAnswer()">新增问答题
                </el-button>
            </template>

            <template slot-scope="scope" slot="menu">
                <el-button v-if="scope.row.type <= 3" icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleSurveyQuestionOption(scope.row)">项目选项({{ scope.row.survey_question_option_count }})
                </el-button>
                <el-button v-if="scope.row.type === 4" icon="el-icon-tickets" size="small" type="text"
                           @click.stop="handleSurveyQuestionAnswer(scope.row)">问答题情况
                </el-button>
            </template>
        </avue-crud>

        <el-dialog title="项目选项" :visible.sync="dialogSurveyQuestionOptionVisible" :modal="false" width="80%" center>
            <SurveyQuestionOption :defaultParams="{questionId : this.questionId }"></SurveyQuestionOption>
        </el-dialog>
        <el-dialog title="问答题情况" :visible.sync="dialogSurveyQuestionAnswerVisible" :modal="false" width="80%" center>
            <SurveyQuestionAnswer :defaultParams="{questionId : this.questionId }"></SurveyQuestionAnswer>
        </el-dialog>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import SurveyQuestionOption from './SurveyQuestionOption'
  import SurveyQuestionAnswer from './SurveyQuestionAnswer'

  export default {
    name: 'SurveyQuestion',
    mixins: [curd],
    props: ['defaultParams'],
    components: {SurveyQuestionOption, SurveyQuestionAnswer},
    data() {
      return {
        url: '/survey/question',
        dialogSurveyQuestionOptionVisible: false,
        dialogSurveyQuestionAnswerVisible: false,
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增文字单选', // 新增按钮文案
          editBtn: true, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中x
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '项目内容',
              overHidden: true,
              prop: 'title',
              span: 24,
              align: 'left'
            },
            {
              label: '项目类型',
              prop: 'type',
              disabled: true,
              span: 24,
              type: 'select',
              html: true,
              dicData: [{'label': '文字单选', 'value': 0}, {'label': '文字多选', 'value': 1}, {'label': '图片单选', 'value': 2}, {'label': '题目多选', 'value': 3}, {'label': '问答题', 'value': 4}],
              formatter: function (row) {
                if (row.type === 0) return '<span style="color: #76b1f9">文字单选</span>';
                if (row.type === 1) return '<span style="color: blue">文字多选</span>';
                if (row.type === 2) return '<span style="color: yellowgreen">图片单选</span>';
                if (row.type === 3) return '<span style="color: green">图片多选</span>';
                return '问答题';
              }
            },
            {
              label: '项目图片',
              prop: 'filepaths',
              dataType: 'string', // 单图不要此属性
              hide: true,
              type: 'upload',
              // listType: 'picture-img', // 单图
              listType: 'picture-card',// 多图
              oss: 'ali', // 阿里云oss配置
              loadText: '附件上传中，请稍等',
              span: 24
            },
            {
              label: '是否必填',
              prop: 'is_require',
              type: 'radio',
              rules: [{
                required: true, message: '请选择是否必填', trigger: 'blur'
              }],
              dicData: [
                {'label': '选填', 'value': 0},
                {'label': '必填', 'value': 1}
              ]
            },
            {
              label: '选项上限',
              prop: 'max_option',
              span: 24,
              type: 'number'
            },
            {
              label: '输入框大小',
              display: false,
              prop: 'input_size',
              span: 24,
              type: 'number'
            },
            {
              label: '字数限制',
              display: false,
              prop: 'word_range',
              span: 24,
              type: 'number'
            },
            {
              label: '排序ID',
              prop: 'sort_id',
              tip: '排序ID越小越靠前',
              value: 100,
              span: 24,
              type: 'number'
            },
            {
              label: '提示语（问答题）',
              display: false,
              hide: true,
              prop: 'hint',
              span: 24
            }
          ]
        },
        questionId: null
      }
    },
    methods: {
      // 选项列表
      handleSurveyQuestionOption(row) {
        this.dialogSurveyQuestionOptionVisible = true;
        this.questionId = row.id;
      },

      // 问答题情况
      handleSurveyQuestionAnswer(row) {
        this.dialogSurveyQuestionAnswerVisible = true;
        this.questionId = row.id;
      },

      // 文字单选
      handleAlone() {
        this.option.column[0].rules = [{required: true, message: '标题不能为空', trigger: 'blur'}]; // 标题必选
        this.option.column[1].value = 0; // 类型
        this.option.column[4].display = false; // 多选上限
        this.option.column[5].display = false; // 输入框大小
        this.option.column[6].display = false; // 字数限制
        this.option.column[8].display = false; // 提示语

        delete this.option.column[2].rules; // 图片去除必选

        this.$refs.crud.rowAdd()
      },

      // 文字多选
      handleMany() {
        this.option.column[0].rules = [{required: true, message: '标题不能为空', trigger: 'blur'}];
        this.option.column[1].value = 1; // 类型
        this.option.column[5].display = false; // 输入框大小
        this.option.column[6].display = false; // 字数限制
        this.option.column[8].display = false; // 提示语

        delete this.option.column[2].rules; // 图片去除必选
        delete this.option.column[4].display; // 多选添加上限

        this.$refs.crud.rowAdd()
      },

      // 图片单选
      handleImageAlone() {
        this.option.column[2].rules = [{required: true, message: '图片不能为空', trigger: 'blur' }]; // 图片添加必选
        this.option.column[1].value = 2;
        this.option.column[4].display = false; // 多选上限
        this.option.column[5].display = false; // 输入框大小
        this.option.column[6].display = false; // 字数限制
        this.option.column[8].display = false; // 提示语

        delete this.option.column[0].rules; // 文字去除必选

        this.$refs.crud.rowAdd()
      },

      // 图片多选
      handleImageMany() {
        this.option.column[2].rules = [{required: true, message: '图片不能为空', trigger: 'blur' }];
        this.option.column[1].value = 3;
        this.option.column[5].display = false; // 输入框大小
        this.option.column[6].display = false; // 字数限制
        this.option.column[8].display = false; // 提示语

        delete this.option.column[0].rules;
        delete this.option.column[4].display; // 多选添加上限

        this.$refs.crud.rowAdd()
      },

      // 问答题
      handleAnswer() {
        this.option.column[0].rules = [{required: true, message: '标题不能为空', trigger: 'blur'}]; // 标题必选
        this.option.column[1].value = 4; // 类型
        this.option.column[4].display = false; // 多选上限

        delete this.option.column[2].rules; // 图片去除必选
        delete this.option.column[5].display; // 图片去除必选
        delete this.option.column[6].display; // 图片去除必选
        delete this.option.column[8].display; // 提示语

        this.$refs.crud.rowAdd()
      },
    }
  }
</script>
